// extracted by mini-css-extract-plugin
export var footer = "_mq-5";
export var fulfillmentInput = "_mq-0";
export var shipDateInput = "_mq-1";
export var shipmentModal = "_mq-2";
export var shipmentModalContent = "_mq-3";
export var tableContainer = "_mq-4";